export enum AssigneeTypes {
  Primary,
  Partner,
  Adviser,
}
